import { OperationType } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type AccountCounterpartyGroup = {
  id: string;
  name: string;
  operationType: OperationType;
};

export const counterpartyGroupsByAccountQueryAtom = createQueryAtomFactory(
  'brokerage.counterpartyGroupsByAccount',
  (params: { accountId: string }) => ({
    counterpartyGroupsByAccount: {
      __args: {
        accountId: params.accountId,
      },
      id: true,
      name: true,
      operationType: true,
    },
  }),
  {
    select: (data): AccountCounterpartyGroup[] => {
      if (!data?.counterpartyGroupsByAccount) return [];
      return data.counterpartyGroupsByAccount.map(
        (g: { id: string; name: string; operationType: OperationType }) => ({
          id: g.id,
          name: g.name,
          operationType: g.operationType as OperationType,
        }),
      );
    },
  },
);
